module.exports = "/assets/8703a16a31b31425297ddae4c78407e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/KM.png
// module id = 1550
// module chunks = 0